import { motion } from "framer-motion";
import { useLang } from "@/i18n";

const PHOTOS = {
  pasion: "/photos/escenario_08.jpg",
  disciplina: "/photos/clase_02.webp",
  comunidad: "/photos/clase_01.webp",
};

export default function Manifesto() {
  const { t } = useLang();
  const m = t.presentation;

  return (
    <section id="academia" className="px-5 py-24 sm:px-8 sm:py-32" data-testid="presentation-section">
      <div className="mx-auto max-w-7xl">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.3em] text-accent"
        >
          {m.label}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-3xl font-extrabold uppercase tracking-tight sm:text-5xl"
        >
          {m.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-4 max-w-2xl text-sm leading-relaxed text-zinc-300 sm:text-base"
        >
          {m.intro}
        </motion.p>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {m.blocks.map((b, i) => (
            <motion.article
              key={b.key}
              data-testid={`presentation-block-${b.key}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-card transition-all duration-300 hover:border-accent/60 hover:shadow-[0_0_40px_rgba(255,0,122,0.15)]"
            >
              <div className="relative h-60 overflow-hidden">
                <img src={PHOTOS[b.key]} alt={`K-HOUSE · ${b.t}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-[linear-gradient(0deg,#14141A_2%,transparent_55%)]" />
                <span className="absolute bottom-3 left-5 font-mono text-xs font-bold tracking-[0.3em] text-accent">/{b.n}</span>
              </div>
              <div className="p-6 pt-2">
                <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight transition-colors duration-300 group-hover:text-accent">{b.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-300">{b.d}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}